module.exports = __webpack_public_path__ + "img/laboGreen.1d056b2e.svg";